var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AiOutlineInfo } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
export var InfoIcon = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return (_jsx("div", __assign({ onClick: onClick, className: twMerge('flex size-[32px] cursor-pointer items-center justify-center rounded-[8px] border border-primary bg-primary/20', className) }, { children: _jsx(AiOutlineInfo, { className: "size-[20px] text-primary" }) })));
};
